/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Aggregate statistics for estimates.
 * @export
 * @interface EstimateStats
 */
export interface EstimateStats {
    /**
     * 
     * @type {number}
     * @memberof EstimateStats
     */
    totalEstimates: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateStats
     */
    insurerEstimates: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateStats
     */
    contractorEstimates: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateStats
     */
    totalValueCents: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateStats
     */
    averageValueCents: number;
}

/**
 * Check if a given object implements the EstimateStats interface.
 */
export function instanceOfEstimateStats(value: object): value is EstimateStats {
    if (!('totalEstimates' in value) || value['totalEstimates'] === undefined) return false;
    if (!('insurerEstimates' in value) || value['insurerEstimates'] === undefined) return false;
    if (!('contractorEstimates' in value) || value['contractorEstimates'] === undefined) return false;
    if (!('totalValueCents' in value) || value['totalValueCents'] === undefined) return false;
    if (!('averageValueCents' in value) || value['averageValueCents'] === undefined) return false;
    return true;
}

export function EstimateStatsFromJSON(json: any): EstimateStats {
    return EstimateStatsFromJSONTyped(json, false);
}

export function EstimateStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateStats {
    if (json == null) {
        return json;
    }
    return {
        
        'totalEstimates': json['totalEstimates'],
        'insurerEstimates': json['insurerEstimates'],
        'contractorEstimates': json['contractorEstimates'],
        'totalValueCents': json['totalValueCents'],
        'averageValueCents': json['averageValueCents'],
    };
}

export function EstimateStatsToJSON(json: any): EstimateStats {
    return EstimateStatsToJSONTyped(json, false);
}

export function EstimateStatsToJSONTyped(value?: EstimateStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalEstimates': value['totalEstimates'],
        'insurerEstimates': value['insurerEstimates'],
        'contractorEstimates': value['contractorEstimates'],
        'totalValueCents': value['totalValueCents'],
        'averageValueCents': value['averageValueCents'],
    };
}

